import styled from 'styled-components';

export const ContainerText = styled.text<{
    fontColor?: string;
    fontSize?: string;
    fontWeight?: string;
    lineHeight?: string;
    textAlign?: string;
}>`
  font-weight: ${({ fontWeight }) => fontWeight ? fontWeight : '400' };
  font-size: ${({ fontSize }) => fontSize ? fontSize : '16px' };
  line-height: ${({ lineHeight }) => lineHeight ? lineHeight : '22px' };;
  color: ${({ fontColor }) => fontColor ? fontColor : '#000'};
  text-align: ${({ textAlign }) => textAlign ? textAlign : 'left'};
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
  'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
  sans-serif;
`
